<template>
  <div class="justify-center flex flex-col h-full" @click.self="$emit('close')">

    <component :is='selectedComponentView'
               class='grow md:max-w-md md:mx-auto md:w-3/4 md:my-auto'
               @close="$emit('close')"
               :component='fromComponent'
               :transform='transform'
               :transforms-and-source='transformsAndSource'
               :partutil='partutil'
               :treeutil='treeutil'
               :key='fromComponent.id'>

      <template #selected='{component}'>
        <div>
          <div class="pbc-component-viewing-top">
            <div  class="pbc-component-viewing" :class='isSelectedClasses(component)'>
              <slot v-if='editingComponent && editingComponent.id === component.id'
                name='editing'
                :is-selected-component='true'
                :component='editingComponent'
                :shadow-component='shadowEditingComponent'
                :move-to='moveTo'
                :select='select'
                :close='close' />
              <component-editing-header :transform='transform'
                        :transforms-and-source='transformsAndSource'
                        :partutil='partutil'
                        :component='component'
                        :key='component.id'
                    :disable-remove='true'
                    :disable-moveto='true'
                    @add='add'
                    class='my-1 md:m-2'
              >
                <template name='default'>
                  <div @click='select(component)' class="cursor-pointer hover:bg-gray-200 w-full">
                    <condensed :transform='transform'
                            :transforms-and-source='transformsAndSource'
                            :partutil='partutil'
                            :component='component'
                            :key='component.id'
                            :disable-icon='true'
                            />
                  </div>
                </template>
              </component-editing-header>
              <slot
                name="selected"
                :component='component'
                />
            </div>

          </div>
          <pbc-button class="add-feature-button" @click='add({component})'>
            <plus-circle :size='24' class="mr-2" />
              Add Feature
          </pbc-button>

        </div>
      </template>
      <template #from='{component, hasSlots}'>
        <slot v-if='editingComponent && editingComponent.id === component.id' name='editing'
          :component='editingComponent'
          :shadow-component='shadowEditingComponent'
          :move-to='moveTo'
          :select='select'
          :close='close' />

        <div class="pbc-component-from"
             :class='isSelectedClasses(component)'>

          <!--
            <pbc-button class="self-center h-8 flex-none mx-1" @click='$emit("remove", {component})'>
              <delete :size='24' />
            </pbc-button>
          -->
          <div class="pbc-component-box pbc-component-type" @click='select(component)'>
            <condensed :component='component'
                       :transform='transform'
                       :transforms-and-source='transformsAndSource'
                       :partutil='partutil'
                       :key='component.id' />
          </div>

          <!--
          <button class="mx-1 pbc-component-chevron-button" @click='select(component)'>
            <pencil class="flex-static" :size='32' />
          </button>
          -->

          <button v-if='hasSlots' class="mx-1 pbc-component-chevron-button" @click='moveTo({component})'>
            <chevron-right class="flex-static" :size='32' />
          </button>

        </div>
      </template>

      <template #after='{component}'>
        <slot name='after' :component='component' />
      </template>

      <template #to='{component}'>
        <div class="self-right pbc-component-to bg-gray-200">
          <button class="w-12 pbc-component-chevron-button absolute left-0 top-0 bottom-0 rounded-r-none" @click='moveTo({component})'>
            <chevron-left class="flex-static" :size='48' />
          </button>
          <condensed class="ml-12 float-left border-l-0" 
                      :transform='transform'
                      :transforms-and-source='transformsAndSource'
                      :partutil='partutil'
                      :component='component'
                      :key='component.id'
                      :show-property-form='false'
                      :disable-edit-icon="true"
                      />

        </div>
      </template>

    </component>

    <portal-target class="bg-gray-200 flex flex-wrap overflow-scroll justify-around border-t border-gray-400" name="to-list" multiple />
    <history name='component-renderer--editing-component' v-model='historyEditingComponent' :emit-empty="true" />
  </div>
</template>
<script>
import { cloneDeep } from 'lodash';
import * as SelectedComponentMapping from '@components/selected/selectedComponentMapping.js';
import ComponentEditingHeader from '@ui/molecules/ComponentEditingHeader.vue';
import Condensed from '@components/molecules/Condensed.vue';
import Treeutil from '@edit/tree/treeutil.js';
import ChevronRight from '@icons/ChevronRight.vue';
import ChevronLeft from '@icons/ChevronLeft.vue';
import Pencil from '@icons/Pencil.vue';
import PlusCircle from '@icons/PlusCircle.vue';
import Delete from '@icons/Delete.vue';

export default {
  props:{
    transform: {
      type: Object,
      required: true
    },
    transformsAndSource: {
      type: Object,
      required: true
    },
    partutil: {
      type: Object,
      required:true
    },
    treeutil:{
      type: Object,
      required: true
    },
    initialEditComponent: {
      type: Object,
      required: false
    }
  },
  data() {
    const fromComponent = this.treeutil.components[0];
    return {
      fromComponent,
      selectedComponentView:null,
      shadowEditingComponent:{},
      editingComponent:this.initialEditComponent || {},
    }
  },
  methods:{
    add(data) {
      this.$emit('add', data);
    },
    select(component) {
      this.editingComponent = component;
    },
    moveTo({component}) {
      this.fromComponent = component;
      this.editingComponent = {};
    },
    isSelectedClasses(component) {
      if (this.editingComponent === component) {
        return ['pbc-component-selected'];
      }
    },
    close() {
      this.editingComponent = {};
    }
  },
  watch:{
    fromComponent:{
      handler(nv) {
        this.selectedComponentView = SelectedComponentMapping.default[nv.type];
        if (!this.selectedComponentView) {
          this.selectedComponentView = SelectedComponentMapping.default.generic;
        }
        //this.editingComponent = nv;
      },
      immediate:true
    },
    editingComponent:{
      handler(nv, ov) {
        this.$emit("change-editing-component", nv);
        this.shadowEditingComponent = cloneDeep(nv);
      },
      immediate: true
    }  
  },
  components:{
    Condensed,
    ChevronLeft,
    ChevronRight,
    Pencil,
    PlusCircle,
    Delete,
    ComponentEditingHeader
  },
  computed: {
    historyEditingComponent: {
      get() {
        return (this.editingComponent||{}).id;
      },
      set(nv) {
        if (typeof(nv) === 'undefined') {
          this.editingComponent = undefined;
        } else {
          const component = this.treeutil.findComponentById(nv);
          this.editingComponent = component;
        }
      }
    }
  }
}
</script>
